<template lang="pug">
  .py-16
    .d-flex.justify-center(v-if="loading")
      v-progress-circular(indeterminate color="primary")
    v-alert.mx-8(v-else-if="loadError" type="info" outlined) 醫師資料不存在或暫時無法載入，請稍後再試。
    v-row.mx-2(v-else :class="{ 'mx-16': $vuetify.breakpoint.mdAndUp }")
      v-col(cols="12" md="6")
        v-img(:src="docBase.filePath?baseURL+docBase.filePath:'/blog_normal.png'" :alt="doctorImageAlt" eager style="border-radius: 12px" aspect-ratio="1")
        DoctorSchedule.mt-3(v-if="$vuetify.breakpoint.mdAndUp")
      v-col.px-8.py-4(cols="12" md="6")
        DocName(:name="`${docBase.docName || ''} 醫師`" tag="h1")
        .text-h6.mt-4.my-subtitle {{ $t('OurTeam_1') }}
        div.my-content.grey--text.text--darken-2(v-for="edu in docEdus" :key="edu.docEduSn") {{ edu.education }}
        .text-h6.mt-4.my-subtitle {{ $t('OurTeam_2') }}
        div.my-content.grey--text.text--darken-2(v-for="exp in docExps" :key="exp.docExpSn") {{ exp.experience }}
        .text-h6.mt-4.my-subtitle {{ $t('Doctor_1') }}
        ul 
          li(v-for="skill in docSkills" :key="skill.docSkillSn") 
            div.my-content.grey--text.text--darken-2 {{ skill.skill }}
      v-col(v-if="$vuetify.breakpoint.smAndDown" cols="12")
        DoctorSchedule.mt-3
</template>

<script>
import DocName from "@/components/common/DocName.vue";
import DoctorSchedule from "@/components/DoctorSchedule.vue";
import { mapGetters } from "vuex";
import axios from "axios";
import { applyDoctorSeo, applyRouteSeo } from "@/services/seo";

export default {
  name: "Doctor",

  components: {
    DocName,
    DoctorSchedule,
  },

  data() {
    return { loading: true, loadError: false, loadSequence: 0 };
  },

  methods: {
    async loadDoctor(uid) {
      const sequence = ++this.loadSequence;
      const isCurrent = () => sequence === this.loadSequence &&
        this.$route.name === "Doctor" && this.$route.params.uid === uid;
      this.loading = true;
      this.loadError = false;
      try {
        // Publish all sections together, so late responses cannot mix two doctors.
        const results = await Promise.all(["", "/edus", "/exps", "/skills", "/shifts"]
          .map(suffix => axios.get(`docBases/${encodeURIComponent(uid)}${suffix}`)));
        if (!isCurrent()) return;
        const [base, ...sections] = results.map(result => result.data);
        if (!base || String(base.DocBaseSn) !== String(uid) || !base.DocName ||
          !sections.every(Array.isArray)) throw new Error("Invalid doctor response");
        ["SetDocBase", "SetDocEdus", "SetDocExps", "SetDocSkills", "SetDocShifts"]
          .forEach((mutation, index) => this.$store.commit(mutation, results[index].data));
        applyDoctorSeo(this.docBase);
      } catch (error) {
        if (!isCurrent()) return;
        this.loadError = true;
        applyRouteSeo(this.$route, { noindex: true });
      } finally {
        if (isCurrent()) this.loading = false;
      }
    },
  },

  computed: {
    ...mapGetters(["docBase", "docEdus", "docExps", "docSkills", "docShifts"]),
    uid() {
      return this.$route.params.uid;
    },
    baseURL() {
      return process.env.VUE_APP_BACKEND_BASE_URL || "/api";
    },
    doctorImageAlt() {
      const name = this.docBase.docName || this.docBase.DocName;
      return name ? `${name} 醫師` : "佑昇生殖中心醫師";
    },
  },

  watch: {
    uid: {
      handler(uid) {
        if (uid) this.loadDoctor(uid);
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.loadSequence += 1;
  },
};
</script>

<style lang="sass" scoped>
.my-subtitle
  letter-spacing: 0.2rem !important

.my-content
  letter-spacing: 0.1rem

td
  text-align: center
  white-space: nowrap
  &.t-double
    border-top: 2px double rgba(0, 0, 0, 0.12) !important
  &.b-double
    border-bottom: 2px double rgba(0, 0, 0, 0.12) !important
  &.t-dotted
    border-top: 1px dotted rgba(0, 0, 0, 0.12) !important
  &.b-dotted
    border-bottom: 1px dotted rgba(0, 0, 0, 0.12) !important
</style>
